/*
 * patient (zod)
 */
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { patients } from "./patient.schema"

/* Select */
export type Patient = z.infer<typeof selectPatientSchema>
export const selectPatientSchema = createSelectSchema(patients)

export const CLIENT_STATUSES = [
	"review_required",
	"education_required",
	"education_scheduled",
	"prescription_required",
	"prescription_scheduled",
	"active",
	"sla_required",
	"sla_scheduled",
	"renewal_required",
	"not_active",
] as const

export type ClientStatus = typeof CLIENT_STATUSES[number]

/* Filters */
export type PatientFilters = z.infer<typeof patientFiltersSchema>
export const patientFiltersSchema = z.object({
	id: z.string().optional(),
	userId: z.string().optional(),
	practitionerId: z.string().optional(),
	active: z.boolean().optional(),
	clientStatus: z.enum(CLIENT_STATUSES).optional(),
})

const dateCoerce = {
	dateOfBirth: z.coerce.date().optional().nullable(),
	vacStartDate: z.coerce.date().optional().nullable(),
	vacApprovalEndDate: z.coerce.date().optional().nullable(),
}

/* Create */
export const createPatientSchema = createInsertSchema(patients)
	.partial(globalCreateExclude)
	.extend(dateCoerce)
export type CreatePatient = z.infer<typeof createPatientSchema>

/* Update */
export const updatePatientSchema = createInsertSchema(patients)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
	.extend(dateCoerce)
export type UpdatePatient = z.infer<typeof updatePatientSchema>
